<div class="relative min-w-sm mx-auto">
  <input
    readonly
    (click)="toggleCalendar()"
    [value]="formattedRange"
    placeholder="Selecione um intervalo"
    class="border bg-white border-gray-400 px-4 py-2 w-full rounded-md focus:outline-none cursor-pointer"
  />

  @if (isCalendarOpen) {
  <div class="absolute z-10 bg-white border border-cinza rounded-lg shadow-md mt-2 w-full">
    <div class="flex justify-between items-center p-4 border-b border-cinza">
      <button (click)="prevMonth()" class="text-xl cursor-pointer">
        <img ngSrc="/icons/prev.svg" alt="prev" width="25" height="25" />
      </button>
      <span class="font-semibold capitalize">{{ monthLabel }} {{ currentYear }}</span>
      <button (click)="nextMonth()" class="text-xl cursor-pointer">
        <img ngSrc="/icons/next.svg" alt="prev" width="25" height="25" />
      </button>
    </div>

    <div class="grid grid-cols-7 text-center px-4 py-2 font-semibold text-gray-600">
      <div>Dom</div>
      <div>Seg</div>
      <div>Ter</div>
      <div>Qua</div>
      <div>Qui</div>
      <div>Sex</div>
      <div>Sáb</div>
    </div>

    <div class="grid grid-cols-7 gap-1 px-4 pb-4">
      <ng-container>
        @for (day of getDaysInMonth(); track $index) { @if (day === null) {
        <div></div>
        }@if (day !== null) {
        <div
          (click)="selectDate(day)"
          class="flex items-center justify-center h-10 w-10 rounded-full cursor-pointer transition"
          [ngClass]="{
            'bg-primary text-white': isStart(day) || isEnd(day),
            'bg-foreground/50 text-black/60': isInRange(day),
            'hover:bg-foreground': true
          }"
        >
          {{ day }}
        </div>
        } }
      </ng-container>
    </div>

    <div class="flex justify-between px-4 pb-4 text-sm text-gray-700">
      <div class="flex gap-2 items-center">
        <span>Início:</span>
        <select class="border rounded px-1 py-1" [(ngModel)]="startHour" (change)="onTimeChange()">
          @for (h of [].constructor(24); track $index) {
          <option [value]="pad($index)">
            {{ pad($index) }}
          </option>
          }
        </select>
        :
        <select
          class="border rounded px-1 py-1"
          [(ngModel)]="startMinute"
          (change)="onTimeChange()"
        >
          @for (m of [].constructor(60); track $index) {
          <option [value]="pad($index)">
            {{ pad($index) }}
          </option>
          }
        </select>
      </div>

      <div class="flex gap-2 items-center">
        <span>Fim:</span>
        <select class="border rounded px-1 py-1" [(ngModel)]="endHour" (change)="onTimeChange()">
          @for (h of [].constructor(24); track $index) {
          <option [value]="pad($index)">
            {{ pad($index) }}
          </option>
          }
        </select>
        :
        <select class="border rounded px-1 py-1" [(ngModel)]="endMinute" (change)="onTimeChange()">
          @for (m of [].constructor(60); track $index) {
          <option [value]="pad($index)">
            {{ pad($index) }}
          </option>
          }
        </select>
      </div>
    </div>
  </div>
  }
</div>
